import { render, staticRenderFns } from "./CardChoice.vue?vue&type=template&id=b2e5ff0c&scoped=true"
import script from "./CardChoice.vue?vue&type=script&lang=js"
export * from "./CardChoice.vue?vue&type=script&lang=js"
import style0 from "./CardChoice.vue?vue&type=style&index=0&id=b2e5ff0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e5ff0c",
  null
  
)

export default component.exports